export default __webpack_public_path__ + "static/media/MP1.f15506dd.jpg";